export default {
  fields: {
    parent_asin_detail: 'Parent ASIN Detail',
    inventory_protection: 'Inventory Protection',
    parent_asin_pricing: 'Parent ASIN Pricing',
    child_fields: {
      sku_details: "Child SKU's Detail",
      calculated_current_price: 'Calculated Current Price',
    },
  },
};
